import _Model from "./_Model";
import IOType from './IOType'

export default class IOTypeWithNumber extends _Model {
  constructor(json) {
    super(json);
    this.ioType = IOTypeWithNumber.getMappedOrDefault(json, 'ioType', null, data => new IOType(data || {}));
    this.number = IOTypeWithNumber.getOrDefault(json, 'number', 0);
  }

}
